import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListBulletIcon, MagnifyingGlassIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

const Aarthikreport = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const reports = [
        { title: "नमुना १ (अंदाजपत्रक)", path: "/namuna1" },
        { title: "नमुना २ (पुनर्विनियोजन अंदाजपत्रक)", path: "/aarthikreportnamuna2" },
        { title: "नमुना ३ (जमा व खर्च)", path: "/aarthikreportnamuna3" },
        { title: "नमुना ४ (पंचायतीचे भत्ते व दाखले)", path: "/aarthikreportnamuna4" },
        { title: "नमुना ५ क (दैनिक रोकड वही)" , path: "/aarthikreportnamuna5k"}, 
        { title: "नमुना ५  (सामान्य रोकड वही)",path: "/aarthikreportnamuna5" },
        { title: "नमुना ६ (महिन्याचे वर्गीकरण)" , path: "/aarthikreportnamuna6"},
        { title: "नमुना ७ (सामान्य पावती)", path: "/aarthikreportnamuna7" },
        { title: "नमुना ११ (किरकोळ मागणी नोंद वही)", path: "/aarthikreportnamuna11" },
        { title: "नमुना १२ (आकस्मिक खर्चाचे प्रमाणक)", path: "/aarthikreportnamuna12" },
        { title: "नमुना १३ (कर्मचारी वर्गाची सुची व वेतनश्रेणी नोंद वही)", path: "/aarthikreportnamuna13" },
        { title: "नमुना १४ (मुद्रांक हिशोब नोंद वही)", path: "/aarthikreportnamuna14" },
        { title: "नमुना १५ (उपभोग वस्तू साठी लेखा नोंदवही)" },
        { title: "नमुना १६ (जड वस्तू संग्रह किंवा जंगम मालमत्ता नोंदवही)" },
        { title: "नमुना १७ (अग्रिम दिलेल्या/ अनामत ठेवलेल्या रकमांची नोंदवही)" },
        { title: "नमुना १८ (किरकोळ रोकड वही)" },
        { title: "नमुना १९ (कामावर असलेल्या व्यक्तींचा हजेरीपट)" },
        { title: "नमुना २० (कामाचा अंदाजाची नोंदवही)" },
        { title: "नमुना २० क (मोजमाप वही)" },
        { title: "नमुना २० ख (कामाचे देयक)" },
        { title: "नमुना २१ (कर्मचा-यांच्या वेतन देयकांची नोंदवही)" },
        { title: "नमुना २२ (स्थावर मालमत्ता नोंदवही(रस्ते व जमिनींव्यतिरिक्त))" },
        { title: "नमुना २३ (ताब्यातील रस्त्याची नोंदवही)" },
        { title: "नमुना २४ (जमीनीची नोंदवही)" },
        { title: "नमुना २५ (गुंतवणूक नोंदवही)" },
        { title: "नमुना २६ क (जमा खर्चाचे मासिक विवरण)" },
        { title: "नमुना २६ ख (मासिक खर्चाचे विवरण)" },
        { title: "नमुना २७ (लेखापरिक्षणातील आक्षेपांच्या पूर्ततेचे मासिक विवरण)" },
        { title: "नमुना २८ (मागासवर्गीय १५% व महिला बाल कल्याण १०% खर्चाचे मासिक विवरण)" },
        { title: "नमुना २९ (कर्जाची नोंदवही)" },
        { title: "नमुना ३० (ग्रामपंचायत लेखापरिक्षण आक्षेप पूर्तता नोंदवही)" },
        { title: "नमुना ३१ (प्रवास भत्ता देयक)" },
        { title: "नमुना ३२ (रकमेच्या परताव्यासाठी आदेश)" },
        { title: "नमुना ३३ (वृक्ष नोंदवही)" },
        { title: "खाते पुस्तिका" },
        { title: "महिन्याचा जमा व खर्च" },
    ];

    const filteredReports = reports.filter((report) =>
        report.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header / Search Section */}
            <div className="bg-[#267c77] text-white p-4 shadow-md">
                <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
                    <h1 className="text-2xl font-bold">आर्थिक रिपोर्ट (Financial Reports)</h1>

                    <div className="relative w-full md:w-1/3 text-black">
                        <input
                            type="text"
                            placeholder="शोधा (Search)..."
                            className="w-full pl-10 pr-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <MagnifyingGlassIcon className="w-5 h-5 absolute left-3 top-2.5 text-gray-500" />
                    </div>
                </div>
            </div>



            <div className="container mx-auto p-6">
                {filteredReports.length === 0 ? (
                    <div className="text-center text-gray-500 mt-10">
                        <p className="text-xl">कोणताही रेकॉर्ड सापडला नाही (No records found)</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {filteredReports.map((report, index) => (
                            <div
                                key={index}
                                className="bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer flex items-center border-l-4 border-rose-500 w-full"
                                onClick={() => {
                                    if (report.path) {
                                        navigate(report.path);
                                    }
                                }}
                            >
                                <div className="p-3 bg-rose-50 rounded-full mr-4 shrink-0">
                                    <ListBulletIcon className="w-6 h-6 text-rose-500" />
                                </div>
                                <h3 className="font-semibold text-gray-800 flex-grow text-left text-sm md:text-base">
                                    {report.title}
                                </h3>
                                <ChevronRightIcon className="w-5 h-5 text-gray-400 ml-2 shrink-0" />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        .animate-marquee {
          animation: marquee 20s linear infinite;
        }
      `}</style>
        </div>
    );
};

export default Aarthikreport;
